import { FadeUp } from "./Reveal";
import { STATS } from "@/data";

export default function Stats() {
  return (
    <section className="bg-[#FF4D00] text-black" data-testid="stats">
      <div className="mx-auto max-w-[1600px] px-6 lg:px-12 py-20 lg:py-28">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-y-12 gap-x-6">
          {STATS.map((s, i) => (
            <FadeUp key={s.label} delay={i * 0.08} className="border-l-2 border-black pl-5">
              <div className="font-display font-black tracking-tighter text-5xl lg:text-7xl leading-none">
                {s.value}
                <span className="text-2xl lg:text-4xl align-top">{s.suffix}</span>
              </div>
              <div className="font-mono text-xs uppercase tracking-[0.2em] mt-4">{s.label}</div>
            </FadeUp>
          ))}
        </div>
      </div>
    </section>
  );
}
